import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from '@/utils/request';
import 'ant-design-vue/dist/antd.css';
import './assets/css/index.scss';
Vue.config.productionTip = false;
import VueLazyLoad from 'vue-lazyload';
import Antd from 'ant-design-vue';
// import echarts from 'echarts';
// 报错 参数有问题,不影响使用,直接忽略掉
// @ts-ignore
// Vue.use(echarts);
Vue.use(Antd);
import Vueaxios from 'vue-axios';
Vue.use(Vueaxios, axios);
Vue.use(VueLazyLoad, {
  loading: require('./assets/images/default.gif'),  // 这个就是你本地图片的地址
  error: 'dist/error.png', // 图片加载失败时使用的图片源
  attempt: 1, // 尝试加载次数
});



router.beforeEach((to:any, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  /*如果需要登录，当前没有登录，直接跳转到登录页*/
  if (to.matched.length === 0) {
    // 如果未匹配到路由
    from.path ? next({ path: from.path }) : next('/');
    // 如果上级也未匹配到路由则跳转主页面，如果上级能匹配到则转上级路由
  } else {
    next();
    // 如果匹配到正确跳转
  }
});


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
